import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import type { AdmAuth } from './AdmGate';

export default function AdmShell({
  auth,
  active,
  children,
}: {
  auth: AdmAuth;
  active: 'root' | 'rg' | 'og' | 'people';
  children: ReactNode;
}) {
  const tabs: { key: 'root' | 'rg' | 'og' | 'people'; label: string; to: string }[] = [];
  if (auth.isRoot) tabs.push({ key: 'people', label: '人員管理', to: '/adm/people' });
  if (auth.isRoot) tabs.push({ key: 'root', label: '授權總覽', to: '/adm' });
  if (auth.isRoot || auth.scopes.has_rg) tabs.push({ key: 'rg', label: 'RG 領域', to: '/adm/rg' });
  if (auth.isRoot || auth.scopes.has_og) tabs.push({ key: 'og', label: 'OG 領域', to: '/adm/og' });

  return (
    <div className="min-h-screen bg-background-50">
      <header className="border-b border-foreground-200/50 bg-background-50">
        <div className="max-w-5xl mx-auto px-4 md:px-6 h-14 flex items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <span className="inline-flex w-8 h-8 rounded-lg bg-accent-500 items-center justify-center">
              <i className="ri-shield-keyhole-line text-base text-background-50" />
            </span>
            <div>
              <p className="text-sm font-semibold text-foreground-900">ADM Center</p>
              <p className="text-xs text-foreground-400">AUM1001 管理者後台</p>
            </div>
          </div>
          <div className="flex items-center gap-3">
            <span className="text-xs text-foreground-500 hidden sm:block">{auth.email}</span>
            <button
              onClick={auth.signOut}
              className="whitespace-nowrap px-3 py-1.5 rounded-md border border-foreground-200 text-xs text-foreground-600 hover:bg-foreground-100 cursor-pointer transition-colors"
            >
              登出
            </button>
          </div>
        </div>
        <div className="max-w-5xl mx-auto px-4 md:px-6 flex items-center gap-1 overflow-x-auto">
          {tabs.map((t) => (
            <Link
              key={t.key}
              to={t.to}
              className={`whitespace-nowrap px-4 py-2 text-sm border-b-2 transition-colors ${
                active === t.key
                  ? 'border-accent-500 text-accent-600 font-medium'
                  : 'border-transparent text-foreground-500 hover:text-foreground-800'
              }`}
            >
              {t.label}
            </Link>
          ))}
        </div>
      </header>
      <main className="max-w-5xl mx-auto px-4 md:px-6 py-8">{children}</main>
    </div>
  );
}
